// Toggle switches
// Ours are implemented by Bootstrap Toggle ()
// Copied from src/static_src/js/c2Archive/toggles.js

(function (c2, $) {
  'use strict';

  /**
   * Set up common on-change behavior of toggle switches: to post to a URL
   * defined by their `data-post-url` attribute.  The name of the input element
   * becomes the key and the value is true or false. This works in conjunction
   * with the server side `common.views.toggle_boolean_property` to apply the
   * change.
   *
   * Optionally specify the selector to use; otherwise applies to all inputs
   * carrying a `data-post-url` (the actual contract — independent of the legacy
   * bootstrap-toggle `data-toggle=toggle` attr, which we are retiring in favor
   * of native Bootstrap 5 form-switches).
   */
  function enablePostOnChange(selector) {
      var $toggles = $(selector || 'input[data-post-url]');
      if ($toggles.length === 0) return

      $toggles.off('change'); // Make idempotent
      $toggles.on('change', function (e) {
          var $box = $(this);
          var url = $box.data('post-url');
          var reloadPageOnToggle = $box.data("reload-page-on-toggle");

          // Bootstrap tooltips default to trigger: 'hover focus'. Clicking the
          // switch focuses it, so a tooltip shown on hover otherwise lingers
          // until focus moves elsewhere. Hide it (and release focus) as soon
          // as the toggle fires, rather than waiting on the user to click
          // something else.
          if ($box.attr('data-bs-toggle') === 'tooltip') {
              $box.tooltip('hide');
          }
          $box.trigger('blur');

          var data = {};
          data[$box.attr('name')] = $box.prop('checked');

          $.post(url, data)
              .done(function (response) {
                  if (response !== null && response.redirectURL) {
                      window.location.href = response.redirectURL;
                  }
                  if (reloadPageOnToggle === "True") {
                      location.reload(true);
                  }
                  if (response.success || response.message) {
                      // The back end sometimes passes a success message for the front end to show to the user.
                      // This is sent in .message rather than .success because the views use .success to generate
                      // the text of history messages (see toggle_boolean_property_with_action_history() as an example)
                      c2.alerts.addGlobalAlert(response.success || response.message, 'success', true);
                  }
                  if (response.error) {
                      c2.alerts.addGlobalAlert(response.error, 'error', true);
                  }
              })
              .fail(function () {
                  c2.alerts.addGlobalAlert("Error when contacting the server. Please reload the page and try again.", 'error', true);;
              });
      });
  }

  c2.toggles = {
    enablePostOnChange: enablePostOnChange
  };
})(window.c2, window.jQuery);
